import as from 'ansis'
import { Command } from 'commander'

import { getUserTeams } from '@/domains/team/helpers'
import { getAuthData, getDatabaseClient } from '@/helpers'
import { output } from '@/helpers/std-out'

export const ListCommand = () => {
  const cmd = new Command('list')

  cmd.description('List all teams current user is part of')
  cmd.action(async () => {
    const auth = await getAuthData()
    auth.addEventListener((state) => Object.assign(auth, state))
    const client = await getDatabaseClient()

    const teams = await getUserTeams(client, auth.email ?? 'default email')

    if (teams.error) {
      return output
        .error()
        .title('An error occurred while getting list of teams.')
        .exit('error')
    }

    // Display the list of teams
    output
      .info()
      .table(
        teams.data.map((it) => {
          const isCurrentTeam = it.teamUid === auth.teamUid
          const color = isCurrentTeam ? as.green : as.blue

          const teamName = isCurrentTeam
            ? `${it.teamName} (default)`
            : it.teamName

          return [isCurrentTeam ? color('➜') : ' ', color(teamName)]
        }),
        { padding: 1 },
      )
      .print()
  })

  return cmd
}
